export function getOrCreateBrowserId(): string {
    let browserId = localStorage.getItem('browser_id');
  
    if (!browserId) {
      // Generate a new UUID
      browserId = crypto.randomUUID();
      localStorage.setItem('browser_id', browserId);
    }
  
    return browserId;
  }